// packages/content/src/tuning/decor.ts — tank footprint by shadow size (index = size)
import type { TuningBank } from '../schema/tuning';
// Index 0 is unused (ShadowSize is 1–6); [0, 0] stands in for null, which TuningValue does not allow.
export default { tankBySize: [[0, 0], [1, 1], [1, 1], [1, 1], [2, 1], [2, 1], [2, 2]], liftHeight: 0.34 } as const satisfies TuningBank;
